export { CaseScheduleApiClient, caseScheduleApiClient } from './cases-api';

export { ApiError, buildApiError } from './api-error';
export type { ApiErrorBody } from './api-error';

export {
  RealtimeService,
  createRealtimeService,
  realtimeService,
} from './realtime-api';
export type {
  RealtimeEventCallback,
  RealtimeConnectionState,
  RealtimeConnectionOptions,
} from './realtime-api';

export type { SidehubResponseDto } from './cases-api';

export type {
  CartCompletenessStatus,
  CaseBuildChecklistSummaryDto,
  CaseBuildChecklistTrackedItemsDto,
  CaseBuildChecklistUntrackedItemsDto,
  CaseBuildStatus,
  CasePaginationParams,
  CaseResponseDto,
  CaseStatus,
  CasesResponseDTO,
  CatalogItemGroupDto,
  ChecklistTrackedItemDto,
  ChecklistUntrackedItemDto,
  SurgicalCaseDTO,
  UntrackedCatalogItemGroupDto,
} from '@peritasai/types';
